<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="mdi-cogs"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="text-h2 font-weight-light">
          {{ $tc('consolidated_invoice', 99) }}
        </div>
      </template>
      <v-row class="mx-0">
        <v-col cols="12">
          <v-textarea
            v-model="packageNumbers"
            :label="$tc('package_number', 99)"
          />
          <v-btn
            :loading="checking"
            :disabled="checking || !packageNumbers"
            color="primary"
            class="ml-auto mt-5"
            @click="checkPackages(false)"
          >
            Find pakker
          </v-btn>
          <v-btn
            :loading="checking"
            :disabled="checking || !packageNumbers"
            color="secondary"
            class="ml-auto mt-5"
            @click="checkPackages(true)"
          >
            Find paller
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        v-if="shipments && shipments.length"
        class="mx-0"
      >
        <v-col cols="3">
          <base-material-card
            v-if="chartData.series && chartData.series.length > 0"
            icon="mdi-chart-bar"
            inline
          >
            <template v-slot:after-heading>
              <div class="text-h2 font-weight-light">
                Har toldinformation
              </div>
            </template>

            <chartist
              :data="chartData"
              type="Bar"
              :options="{
                axisY: {
                  onlyInteger: true,

                },
                chartPadding: 30,
                distributeSeries: true
              }"
            />
          </base-material-card>
        </v-col>
        <v-col cols="9">
          <base-material-card
            icon="mdi-tag"
            inline
          >
            <template v-slot:after-heading>
              <div class="text-h2 font-weight-light">
                {{ $tc('shipments', 99) }}
              </div>
            </template>

            <v-data-table
              :headers="headers"
              :items="shipments"
              dense
              class="elevation-1"
            >
              <template v-slot:item.has_customs="{item}">
                <v-icon
                  v-if="item.has_customs"
                  color="green"
                >
                  check
                </v-icon>
                <v-icon
                  v-else
                  color="red"
                >
                  not_interested
                </v-icon>
              </template>
            </v-data-table>
            <v-row align="end">
              <v-col cols="1">
                <v-btn
                  color="primary"
                  class="ml-auto mt-5"
                  @click="createConsolidatedInvoice"
                >
                  Dan samlefaktura
                </v-btn>
              </v-col>
            </v-row>
          </base-material-card>
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
  import localstorage from '../../../../plugins/localstorage'
  import { SUPPORT, URL_PREFIX } from '../../../../utils/constants'
  import Qs from 'qs'

  export default {
    data () {
      return {
        crudl: {
          C: SUPPORT.val,
          R: SUPPORT.val,
          U: SUPPORT.val,
          D: SUPPORT.val,
          L: SUPPORT.val,
        },
        packageNumbers: '',
        shipments: null,
        checking: false,
        headers: [
          {
            sortable: false,
            text: this.$t('customs'),
            value: 'has_customs',
          },
          {
            sortable: false,
            text: this.$t('customer_id'),
            value: 'customer_id',

          },
          {
            sortable: false,
            text: this.$t('id'),
            value: 'id',
          },
          {
            sortable: false,
            text: this.$t('package_number'),
            value: 'package_number',
            width: '100%',

          },
        ],
      }
    },
    computed: {
      chartData: function () {
        return {
          labels: [this.$t('yes'), this.$t('no')],
          series: Object.values({ true: 0, false: 0, ...this.$_.countBy(this.shipments, 'has_customs') }),
        }
      },
      localStorage: () => localstorage,

    },
    mounted: function () {
    },
    methods: {
      checkPackages: function (pallets) {
        const numbers = this.packageNumbers.split('\n')
        this.checking = true
        this.$post('consolidated-invoices/check', { numbers, pallets }).then(({ data }) => {
          this.shipments = data
        })
          .finally(() => {
            this.checking = false
          })
      },
      createConsolidatedInvoice: function () {
        const shipments = this.$_.groupBy(this.shipments, 'has_customs')
        const withCustoms = this.$_.map(shipments?.true, 'id')
        const withoutCustoms = this.$_.map(shipments?.false, 'package_number').join('\n')

        const params = {
          shipments: withCustoms,
          access_token: this.localStorage.get('token'),
        }
        const query = Qs.stringify(params, { arrayFormat: 'brackets' })
        window.open(`${URL_PREFIX}/panel/consolidated-invoices?${query}`, '_blank')
        this.$copyText(withoutCustoms).then(() => {
          this.$toast('Pakkenumre uden toldinformation kopieret', { color: 'yellow' })
        })
      },

    },
  }
</script>

<style>
.ct-bar{
	stroke-width: 40px;
}

.ct-series-a .ct-bar{
	stroke: #4caf50 !important;
}

.ct-series-b .ct-bar{
	stroke: #f05b4f !important;
}
</style>
